import { FormHelperText, InputLabel, Stack } from '@mui/material';
import { useField } from 'formik';
import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { XmlEditor, XmlEditorVariant } from '../xml/xmlEditor';

export const XmlField = ({
  name,
  icon,
  intlLabelId,
  variant
}: {
  name: string;
  icon?: ReactNode;
  intlLabelId?: string;
  variant?: XmlEditorVariant;
}) => {
  const [field, meta, helpers] = useField(name);
  const intl = useIntl();
  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1}>
        {icon}
        {intlLabelId && (
          <InputLabel>
            {intl.formatMessage({
              id: intlLabelId
            })}
          </InputLabel>
        )}
      </Stack>
      <XmlEditor
        onBlur={() => helpers.setTouched(true)}
        onChange={(value) => helpers.setValue(value)}
        value={field.value}
        variant={variant}
      />
      {meta.error && meta.touched && <FormHelperText error>{meta.error}</FormHelperText>}
    </Stack>
  );
};
